import { render, staticRenderFns } from "./LoginResetPassword.vue?vue&type=template&id=d613792e&"
import script from "./LoginResetPassword.vue?vue&type=script&lang=js&"
export * from "./LoginResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QItem,QSpinner,QBtn,QInput,QIcon,QInnerLoading,QSpinnerGears,QSeparator,QCardActions} from 'quasar'
component.options.components = Object.assign({QDialog,QCard,QCardSection,QItem,QSpinner,QBtn,QInput,QIcon,QInnerLoading,QSpinnerGears,QSeparator,QCardActions}, component.options.components || {})
